import CronLightPlugin from '@vue-js-cron/light'
import { CronLight } from '@vue-js-cron/light'
import '@vue-js-cron/light/dist/light.css'
import type { App } from 'vue'

export function registerCron(app: App) {
  app.use(CronLightPlugin)
  app.component('CronLight', CronLight)
}
